
import Vue from "vue";
import * as action from "@/store/actions";
import { mapActions, mapGetters } from "vuex";
import i18n from "@/plugins/i18n";
import msgCodes from "@/extendedFunctions/msgCodes";
export default Vue.extend({
  props: {
    isToNew: Boolean,
    isToEdit: Boolean,
    timeToUpdate: Object
  },
  data() {
    return {
      originalOptions: [] as { id: number; from: string; to: string; days: string }[],
      dialog: false,
      valid: true,
      menuFrom: false,
      menuTo: false,
      form: {
        name: "",
        // Ahora days es string con guiones, ej: "Mon-Tue"
        options: [] as { from: string; to: string; days: string }[]
      },
      tempOption: {
        from: "",
        to: "",
        days: [] as string[]
      },
      days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      dayShortMap: {
        Monday: "Mon",
        Tuesday: "Tue",
        Wednesday: "Wed",
        Thursday: "Thu",
        Friday: "Fri",
        Saturday: "Sat",
        Sunday: "Sun",
      },
    };
  },
  computed: {
    canAddOption(): boolean {
      return (
        this.tempOption.days.length > 0 &&
        !!this.tempOption.from &&
        !!this.tempOption.to
      );
    },
    rules() {
      return {
        required: (v: string) => !!v || this.$t("logingview.required")
      };
    }
  },
  methods: {
    ...mapActions({
      newTimeMain: "crudService/newObject",
      updateTimeMain: "crudService/updateObject",
    }),
    translatedDays(daysStr: string): string {
      return daysStr
        .split("-")
        .map(abbr => this.$t(`days.${abbr}`))
        .join(" / ");
    },

    formatTime(time: string): string {
      if (!time) return "";
      if (time.includes(":")) return time;
      if (time.length === 4) {
        const hours = time.slice(0, 2);
        const minutes = time.slice(2);
        return `${hours}:${minutes}`;
      }

      return time; // fallback
    },
    toggleDay(day: string) {
      const index = this.tempOption.days.indexOf(day);
      if (index === -1) this.tempOption.days.push(day);
      else this.tempOption.days.splice(index, 1);
    },
    addOption() {
      const { from, to, days } = this.tempOption;

      if (!from || !to || days.length === 0) {
        this.$store.dispatch("snackbar/showSnack", {
          message: this.$t("rules.allFieldsRequired"),
          color: "error",
          timeout: 3000,
        });
        return;
      }

      // Validación: desde < hasta
      const fromMinutes = parseInt(from.split(":")[0]) * 60 + parseInt(from.split(":")[1]);
      const toMinutes = parseInt(to.split(":")[0]) * 60 + parseInt(to.split(":")[1]);

      if (fromMinutes >= toMinutes) {
        this.$store.dispatch("snackbar/showSnack", {
          message: this.$t("misc.startBeforeEnd"),
          color: "error",
          timeout: 3000,
        });
        return;
      }

      const daysAbbr = days.map(day => this.dayShortMap[day] || day).join("-");

      this.form.options.push({
        days: daysAbbr,
        from,
        to,
      });

      this.tempOption = { from: "", to: "", days: [] };
    },
    removeOption(index: number) {
      this.form.options.splice(index, 1);
    },
    async save() {
      if (!this.form.name) {
        this.$refs.form.validate();
        return;
      }

      if (!this.form.options.length) {
        this.$store.dispatch("snackbar/showSnack", {
          message: this.$t("rules.oneDayMin"),
          color: "error",
          timeout: 3000,
        });
        return;
      }

      const deletedOptionIds = this.originalOptions
        .filter(orig => !this.form.options.find(opt => opt.id === orig.id))
        .map(opt => opt.id);

      const payload = {
        id: this.timeToUpdate?.id,
        name: this.form.name,
        options: this.form.options.map(opt => ({
          id: opt.id || 0,
          from: opt.from,
          to: opt.to,
          days: opt.days
        })),
        deletedOptionIds
      };

      let response;
      if (this.isToNew) {
        response = await this.newTimeMain({ action: action.TIMEOPTION_EXTEN_CONTROLLER, obj: payload });
      } else if (this.isToEdit) {
        response = await this.updateTimeMain({ action: action.TIMEOPTION_EXTEN_CONTROLLER, obj: payload });
      }

      this.dialog = response >= 400;

      this.alertMessage = msgCodes(response, this.isNew).alertMessage;
      this.alertType = msgCodes(response, this.isNew).alertType;

      this.$store.dispatch("snackbar/showSnack", {
        message: this.alertMessage,
        color: this.alertType,
        timeout: 3000,
      });

      this.$emit("refreshList", payload);
      this.dialog = false;
    }
  },
  watch: {
    dialog(val: boolean) {
      if (val && this.isToEdit && this.timeToUpdate) {
        this.form.name = this.timeToUpdate.name;
        this.form.options = this.timeToUpdate.options.map((opt: any) => ({
          id: opt.id,
          from: opt.from,
          to: opt.to,
          days: opt.days
        }));
        this.originalOptions = [...this.form.options];
      }

      if (val && this.isToNew) {
        this.form.name = "";
        this.form.options = [];
        this.originalOptions = [];
        this.tempOption = { from: "", to: "", days: [] };
      }
    }
  }
});
